import { render } from "./SalesThisMonthChart.vue?vue&type=template&id=1d83e6d5&scoped=true&ts=true"
import script from "./SalesThisMonthChart.vue?vue&type=script&lang=ts"
export * from "./SalesThisMonthChart.vue?vue&type=script&lang=ts"

import "./SalesThisMonthChart.vue?vue&type=style&index=0&id=1d83e6d5&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d83e6d5"]])

export default __exports__